var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.2222C20 29.6937 19.818 30.1459 19.4941 30.4793C19.1702 30.8127 18.7308 31 18.2727 31H2.72727C2.26917 31 1.82983 30.8127 1.50591 30.4793C1.18198 30.1459 1 29.6937 1 29.2222V19.4444C1 18.9729 1.18198 18.5208 1.50591 18.1874C1.82983 17.854 2.26917 17.6667 2.72727 17.6667H6.18182L7.90909 15H13.0909L14.8182 17.6667H18.2727C18.7308 17.6667 19.1702 17.854 19.4941 18.1874C19.818 18.5208 20 18.9729 20 19.4444V29.2222Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 27C12.433 27 14 25.433 14 23.5C14 21.567 12.433 20 10.5 20C8.567 20 7 21.567 7 23.5C7 25.433 8.567 27 10.5 27Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12V9C3 5.68629 5.68629 3 9 3H13",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3L23 3C26.3137 3 29 5.68629 29 9L29 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20L29 23C29 26.3137 26.3137 29 23 29L20 29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshots);
export default __webpack_public_path__ + "static/media/screenshots.ad3fc316c62b2ba189e69f4fad0dadae.svg";
export { ForwardRef as ReactComponent };